import useTranslations from "@/shared/lang/useTranslations";

import { DEPOSIT_CVUS_CORRIDOR } from "../services/depositAccounts.service";
import { DepositAccountsPage } from "./DepositAccountsPage";

/**
 * `/app/payments-config/deposit-cvus` — INTERNAL staff config of the Argentina receiving CVUs (the CVU ↔
 * organization mapping that attributes push-detected ARS deposits). Thin binding of the generic
 * `DepositAccountsPage` to the CVUs corridor.
 */
const DepositCvusPage = () => {
  const { t: tGlobal } = useTranslations("global");
  return (
    <DepositAccountsPage
      corridor={DEPOSIT_CVUS_CORRIDOR}
      breadcrumbLabel={tGlobal("sidebar_menu_deposit_cvus")}
      route="/app/payments-config/deposit-cvus"
    />
  );
};

export default DepositCvusPage;
